import React, { FunctionComponent } from 'react';
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';

import { ComponentSide, JackSettings } from '@paragon/contract-library';

import { updateActiveJackSettings } from '../../../../store/actions/profileActions';
import { getComponentDesignBeingInserted } from '../../../../store/selectors/insertionObjectSelectors';
import { useAppDispatch, useAppSelector } from '../../../hooks';

interface Props {
  readonly disabled?: boolean;
  readonly value: JackSettings | null;
  readonly onChange: (newValue: JackSettings | null) => void;
}

const defaultSettings: JackSettings = { isOpen: true, side: 'Right' };

const JackSettingsSubPanel: FunctionComponent<Props> = (props) => {
  const toggleJack = () => props.onChange(props.value ? null : defaultSettings);

  const updateSetting = <K extends keyof JackSettings>(key: K, item: JackSettings[K]) =>
    props.onChange(!props.value ? null : { ...props.value, [key]: item });

  const toggleIsOpen = () => updateSetting('isOpen', !props.value!.isOpen);

  const sideChange = (event: SelectChangeEvent<ComponentSide>) =>
    updateSetting('side', event.target.value as ComponentSide);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', flexDirection: 'row', flex: 1, p: 1, justifyContent: 'space-around' }}>
        <FormControlLabel
          sx={{ m: 1 }}
          control={<Checkbox checked={!!props.value} onChange={toggleJack} />}
          label="Jack"
          disabled={props.disabled}
        />
        <FormControl disabled={!props.value}>
          <FormControlLabel
            sx={{ m: 1 }}
            control={<Checkbox checked={!props.value ? false : props.value.isOpen} onChange={toggleIsOpen} />}
            label="Open"
          />
        </FormControl>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'row', flex: 1, p: 1, justifyContent: 'space-around' }}>
        <FormControl disabled={!props.value} variant="outlined" size="small" sx={{ m: 1, width: '100%' }}>
          <InputLabel htmlFor="jack-side">Carried Side</InputLabel>
          <Select
            value={props.value ? props.value.side : ''}
            onChange={sideChange}
            inputProps={{ id: 'jack-side' }}
            disabled={props.disabled}
            label="Carried Side"
          >
            <MenuItem value="Left">Left</MenuItem>
            <MenuItem value="Right">Right</MenuItem>
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
};

export const ActiveComponentJackSettings = () => {
  const dispatch = useAppDispatch();
  const profile = useAppSelector((state) => getComponentDesignBeingInserted(state)?.profile);

  return (
    <JackSettingsSubPanel
      disabled={!profile}
      value={profile?.jackSettings ?? null}
      onChange={(newValue) => dispatch(updateActiveJackSettings(newValue))}
    />
  );
};
